import { render, staticRenderFns } from "./Measurement.vue?vue&type=template&id=1c108124&"
import script from "./Measurement.vue?vue&type=script&lang=js&"
export * from "./Measurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports